import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { createDocumentationQRPath } from 'utilities/qrPaths';
import UtagHelper from 'utilities/utagHelper';
import { FormattedText } from 'core/i18n';
import { doTagQRDocumentationView } from './tagging';
import { ORIGIN_BY_CHANNEL } from 'constants/uTagConstants/origin';
import { setPageName } from 'actions/errorViewNavigation';

const QRDocumentationViewComponent = ({ userProfile, welcomeCard, isDocumentRetryBeenShown, setPageName }) => {
    useEffect(() => {
        !welcomeCard &&
            doTagQRDocumentationView({
                identityMethod: userProfile.identityMethod,
                jointHolderInfo: UtagHelper.getJointHolderInfoFromUserProfile(userProfile),
                investmentType: userProfile.investmentType,
                product: userProfile.product,
                promoCode: userProfile.promoCode,
                recordId: userProfile.recordId,
                userId: userProfile.userId,
                isDocumentRetryBeenShown,
                onboardingOrigin: ORIGIN_BY_CHANNEL[userProfile.channel],
                docNumber: userProfile.docNumber,
                onboardingR: userProfile.clientRisk,
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="documentation-qr">
            <img src={createDocumentationQRPath()} alt="qr-code" />
            <p className="documentation-qr__text documentation-qr__text--title">
                <FormattedText value="uploads-qrShouldContinueOnMobile" />
            </p>
            <p className="documentation-qr__text">
                <FormattedText value="uploads-scanQr" />
            </p>
            <p className="documentation-qr__text">
                <FormattedText value="uploads-qrRememberAccesKey" />
            </p>
        </div>
    );
};

export const QRDocumentationView = connect(null, dispatch => ({
    setPageName: bindActionCreators(setPageName, dispatch),
}))(QRDocumentationViewComponent);
